import {
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
} from '@chakra-ui/react'
import { Eye } from 'lucide-react'
import { useState } from 'react'
import { FieldValues, Path } from 'react-hook-form'

import { Inputs } from './models'

interface MyProps<T extends FieldValues, K extends Path<T>>
  extends Inputs.InputData<T, K>,
    InputProps {}

export default function <T extends FieldValues, K extends Path<T>>(
  props: MyProps<T, K>,
) {
  const {
    useForm: { register },
    useFormField,
    ...rest
  } = props

  const [show, setShow] = useState(false)

  return (
    <InputGroup>
      <Input
        type={show ? 'text' : 'password'}
        {...register(useFormField)}
        {...rest}
      />

      <InputRightElement>
        <IconButton
          aria-label="Mostrar/Ocultar"
          icon={<Icon as={Eye} />}
          onClick={() => setShow((prev) => !prev)}
          variant="ghost"
        />
      </InputRightElement>
    </InputGroup>
  )
}
